import { FormHandle } from '@/hooks/use-form-handle.hook';
import classNames from 'classnames';
import { FormikValues } from 'formik';
import { FC, ReactNode, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import { UseQueryResult } from 'react-query';

interface Props {
  children: ReactNode;
  formHandle: FormHandle<FormikValues>;
  query?: UseQueryResult;
  data?: FormikValues;
  className?: string;
}

const useStyles = createUseStyles({
  form: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});

export const Form: FC<Props> = ({ formHandle, children, query, className = '', data }) => {
  const { handleSubmit, loadData } = formHandle;
  const { data: queryData } = query || {};
  const styles = useStyles();
  const compClass = classNames(styles.form, className);

  useEffect(() => {
    if (queryData || data) {
      const controlData = queryData || data;
      const formData = (Array.isArray(controlData) ? controlData[0] : controlData) as FormikValues;
      loadData(formData);
    }
  }, [data, queryData, loadData]);

  return (
    <form className={compClass} onSubmit={handleSubmit}>
      {children}
    </form>
  );
};
